import { lazyPreload } from 'helpers/lazyPreload'

export const Account = lazyPreload(() =>
  import('./Account').then((m) => ({ default: m.Account })),
)

export const Email = lazyPreload(() =>
  import('./Email').then((m) => ({ default: m.Email })),
)

export const EmailConsentVariant1 = lazyPreload(() =>
  import('./Email').then((m) => ({ default: m.EmailConsentVariant1 })),
)

export const EmailFactory = lazyPreload(() =>
  import('./Email').then((m) => ({ default: m.EmailFactory })),
)

export const EmailV1 = lazyPreload(() =>
  import('./Email').then((m) => ({ default: m.EmailV1 })),
)

export const SignUp = lazyPreload(() =>
  import('./SignUp').then((m) => ({ default: m.SignUp })),
)
